<template>
	<div v-if="isload" class="createorder_export1">
		<el-row style="margin-bottom:25px;">
			<el-col :span="12"><senderaddr ref="senderaddr" title="寄件信息" l_mode="寄件人信息-进口"></senderaddr></el-col>
			<el-col :span="12"><receiveraddr ref="receiveraddr" title="收件信息" l_mode="收件人信息-进口"></receiveraddr></el-col>
			<el-col :span="24">
				<packagecargo ref="packagecargo" :gridheight="gridheight" title="商品明细" l_mode="包裹信息列表-进口" @formScrollTop="formScrollTop"></packagecargo>
			</el-col>
		</el-row>
		<el-row v-if="!btnhidden" class="footerhandler">
			<el-col :span="6" class="submitBtn_switch" style="text-align: right;">
				<el-switch v-model="sendremind" active-text="发送提醒" inactive-text="" active-value="true" inactive-value="false"></el-switch>
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="650px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">下单成功</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="5" style="text-align:right;padding-right: 20px;">
					<el-button type="warning" size="medium" @click="printmd" style="background-color:#c86f67;border-color:#c86f67">打印面单</el-button>
				</el-col>
				<el-col :span="5" style="text-align:right;padding-right: 20px;"><el-button type="warning" size="medium" @click="perviewmd">预览面单</el-button></el-col>
				<el-col :span="6"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="5"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="2" style="text-align: right;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row style="margin-top:25px">
				<el-col :span="2" style="text-align:right;color:transparent">1</el-col>
				<el-col :span="20"><el-link @click="wintips = true" style="color:#409EFF">预览没反应？请点这里查看解决方案</el-link></el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="wintips" center width="70%" :close-on-click-modal="true" :show-close="true" :append-to-body="true">
			<img src="../../static/system_01/image/tips.png" style="width:100%" />
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import senderaddr from '@/components/address/senderaddr_ssq.vue';
import receiveraddr from '@/components/address/receiveraddr_ssq.vue';
import packagecargo from '@/components/order/import_package_cargo.vue';
import printhandler from '@/components/order/printhandler.vue';

export default {
	components: {
		senderaddr,
		receiveraddr,
		packagecargo,
		printhandler
	},
	props: {},
	data() {
		return {
			syscol: '',
			gridheight: '200px',
			orderinfo: {},
			p_pkval:'',
			// pkval:'',
			iscopy: 0,
			btnhidden: false,
			sendremind: false,
			isload: false,
			checkedpmode: '',
			t_id: '',
			showsuccesswin: false,
			wintips: false,
			divclass:'createorder_export1'
		};
	},
	methods: {
		init(param) {
			var that = this;
			this.isload = false;
			if (param.checkedpmode != undefined) this.checkedpmode = param.checkedpmode;
			if (param.syscol != undefined) this.syscol = param.syscol;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.t_id != undefined) this.t_id = param.t_id;
			if (this.syscol != '') {
				//debugger
				this.isload = true;
				this.$nextTick(function() {
					that.$refs.senderaddr.init({ syscol: that.syscol, orderinfo: that.orderinfo});

					that.$refs.receiveraddr.init({ syscol: that.syscol, orderinfo: that.orderinfo});

					that.$refs.packagecargo.init({ syscol: that.syscol, orderinfo: that.orderinfo, iscopy: that.iscopy });
					
				});
			}
		},
		//获取订单信息
		getorderObj() {
			//debugger
			var that = this;
			var error = '';
			var sender = '',
				receiver = '',
				orderlist = [];
			var orderinfo = {};
			var setlist = this.$refs.senderaddr._data.setlist;
			if (setlist.length > 0) {
				setlist.forEach(e => {
					if (e.value == undefined) {
						e.value = '';
					}
					if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
						error = '请填写' + that.$refs.senderaddr.title + '-' + e.showname;
						sender = '';
					} else {
						if (error == '') {
							if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!that.$tool.checkidcardformat(e.value)) {
									error = that.$refs.senderaddr.title + '-' + e.showname + '格式不正确';
									sender = '';
								}
							}
						}
					}
					if (error == '') sender += '"' + e.colname + '":"' + e.value + '",';
					else return false;
				});
				if (error == '') {
					if (sender != '') {
						sender = sender.replace(/\n/g, '');
						sender = '{' + sender.substring(0, sender.length - 1) + '}';
						orderinfo.sender = JSON.parse(sender);
					}
				}
			}
			if (error == '') {
				setlist = this.$refs.receiveraddr._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.receiveraddr.title + '-' + e.showname;
							receiver = '';
						}
						if (error == '') {
							if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!that.$tool.checkidcardformat(e.value)) {
									error = that.$refs.receiveraddr.title + '-' + e.showname + '格式不正确';
									receiver = '';
								}
							}
						}
						if (error == '') receiver += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (receiver != '') {
						receiver = receiver.replace(/\n/g, '');
						receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
						orderinfo.receiver = JSON.parse(receiver);
					}
				}
			}
			if (error == '') {
				var pageset = this.$refs.packagecargo._data.pageset;
				var cargorow = this.$refs.packagecargo._data.columns;
				var index = 0;
				var list = [],
					cargolist = [];
				var baginfo = '';
				pageset.forEach(e => {
					index++;
					baginfo = '';
					cargolist = [];
					e.setlist.forEach(b => {
						if (b.value == undefined) {
							b.value = '';
						}
						if (b.controltype == 'combox-input' && b.ishidden == 'False') {
							var volume = b.combox;
							for (var k = 0; k < volume.length; k++) {
								if (volume[k].value == undefined) {
									volume[k].value = '';
								}
								if (volume[k].isnull == 'False' && volume[k].value == '') {
									error = '请填写第' + index + '个包裹的' + volume[k].showname;
									break;
								}
								baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
							}
						} else if (b.controltype == 'table' && b.ishidden == 'False') {
							if (b.isnull == 'False') {
								if (b.cargolist.length > 0) {
									var cargoindex = 0;
									b.cargolist.forEach(cargo => {
										cargoindex++;
										for (var col in cargo) {
											cargorow.forEach(c => {
												if (col == c.field) {
													if (c.isnull == 'False' && c.colshow == '1') {
														if (cargo[col] == '') error = '【第' + cargoindex + '行】' + c.title + '为空';
													}
													return false;
												}
												if (error != '') return false;
											});
											if (error != '') return false;
										}
										if (error != '') return false;
									});
								} else error = '请填写第' + index + '个包裹的' + b.showname;
							}
							if (error == '') cargolist = b.cargolist;
						} else if (b.ishidden == 'False') {
							if (b.isnull == 'False' && b.value == '') error = '请填写第' + index + '个包裹的' + b.showname;
							else baginfo += '"' + b.colname + '":"' + b.value + '",';
						}
					});
					if (error != '') {
						list = [];
						return false;
					} else {
						if (baginfo != '') {
							baginfo = baginfo.replace(/\n/g, '');
							baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
						} else {
							baginfo = '{}';
						}
						list.push({ idx: index, baginfo: JSON.parse(baginfo), cargolist: JSON.parse(JSON.stringify(cargolist)) });
					}
				});
				orderinfo.list = list;
			}
			if (error != '') {
				this.$tool.message(error, 0);
				orderinfo = '';
				return false;
			}
			return orderinfo;
		},
		//保存订单
		saveorder() {
			var that = this;
			//debugger
			var orderinfo = this.getorderObj();
			if (orderinfo != '') {
				orderinfo.u_userid = localStorage.getItem('userid');
				orderinfo.p_mode = this.checkedpmode;
				orderinfo.t_id = this.t_id;
				if(this.$parent.p_pkval!=undefined){
					orderinfo.editid=this.$parent.p_pkval;
					this.$tool.loading('正在保存', this.$parent.divclass);
				}
				else
				{
					orderinfo.editid=this.$parent.$parent.p_pkval;
					this.$tool.loading('正在保存', this.$parent.$parent.divclass);
				}
				//console.log('orderinfo',escape(JSON.stringify(orderinfo)));
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '1') {
						if(this.$parent.p_pkval!=undefined)
							that.$parent.p_pkval=res.pkval;
						else
							that.$parent.$parent.p_pkval=res.pkval;
						that.p_pkval = res.pkval;
						this.$apipost.post.ThreadResolve_cg({ p_batch: res.batch }).then(res => {});
						that.showsuccesswin = true;
						that.saveaddress(orderinfo);
						if(that.sendremind=='true'){
							orderinfo.p_pkval=that.p_pkval;
							that.$tool.SendMessage(
							{msgid:'38-1',info:orderinfo,pkval:that.p_pkval,type:'1-q',showerror:false},that);
						}	
					} else that.$tool.message(res.message, 0);
				});
			}
		},
		cancel() {
			this.$emit('cancel');
		},
		formScrollTop() {
			this.$emit('formScrollTop');
		},
		//预览面单
		perviewmd() {
			this.$tool.loading('正在获取打印模板', 'createorder');
			this.$refs.printhandler.init({
				pageparam: this._data,
				isgrid: false,
				pkval: this.p_pkval,
				searchinfo: '',
				funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
				handtype: 12, //12--取单号+预览
				isrollback: false,
				ecode: '',
				expresscomname: '',
				parentpage: this,
				isprint: 0
			});
		},
		printmd() {
			this.$tool.loading('正在获取打印模板', this.divclass);
			this.$refs.printhandler.init({
				pageparam: this._data,
				isgrid: false,
				pkval: this.p_pkval,
				searchinfo: '',
				funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
				handtype: 13, //13--新方法取单号+打印
				isrollback: false,
				ecode: '',
				expresscomname: '',
				parentpage: this,
				isprint: 1
			});
		},
		successfun(type) {
			var that = this;
			that.showsuccesswin = false;
			if (type == 0) {
				//关闭
				this.cancel();
			} else if (type == 1) {
				//复制新增
				this.p_pkval='';
			} else if (type == 2) {
				this.p_pkval='';
				this.$parent.p_pkval='';
				//新增订单，清空界面上所有填写的
				this.init({orderinfo:{p_mode:this.checkedpmode}});
			}
		},
		//保存收寄件地址用于下次寄件
		saveaddress(orderinfo){
			var sender=orderinfo.sender;
			var receiver=orderinfo.receiver;
			if(sender!=undefined){
				//debugger
				var paraminfo={u_userid:localStorage.getItem('userid')};
				for(var j in sender){
					var colname=j.substring(2,j.length);
					paraminfo[colname]=sender[j];
				}
				this.$apipost.post.SaveaddressCt({ paraminfo: paraminfo }).then(res => {
					console.log(res);
				});
			}
			if(receiver!=undefined){
				var paraminfo={u_userid:localStorage.getItem('userid')};
				for(var j in receiver){
					var colname=j;
					if(j!='postcode'&&j!='areacode')
						colname=j.substring(2,j.length);
					
					paraminfo[colname]=receiver[j];
				}
				
				this.$apipost.post.SaveaddressCg({ paraminfo: paraminfo }).then(res => {
					console.log(res);
				});
			}
		}
	}
};
</script>

<style></style>
